export default "__VITE_ASSET__DIVfg3zM__"